<!--票据打印页面-->
<template>
    <a-card :bordered="false" :class="{'abcdefg':true}">
      <div class="no-print" style="text-align: right;margin-bottom: 20px">
        <a-button v-print="'#printContent'" ghost type="primary">{{ $t('打印') }}</a-button>
      </div>
      <section ref="print" id="printContent" class="print-section">
          <!--
        <div style="text-align: center">
          <p style="font-size: 24px;font-weight: 800">{{ $t('大兴水厂用户缴费收据') }}</p>
        </div>
        -->
        <table id="table" style="height: 45mm;width:169mm;table-layout: fixed;">
            <tr>
            <td colspan="7" style="border-width: 0"><span style="font-size: 20px;font-weight: 800">{{ $t('山阴县自来水公司销售凭证') }}</span></td>
          </tr>
          <tr>
            <td colspan="7" style="border-width: 0;text-align:left">{{ $t('日期：') }} {{model.updateTime?model.updateTime:model.createTime}}</td>
          </tr>
          <tr>
            <td>{{ $t('用户名') }}</td>
            <td colspan="3">{{model.userName}}</td>
            <td>{{ $t('用户编号') }}</td>
            <td colspan="2">{{model.meterUserId}}</td>
          </tr>
          <tr>
            <td>{{ $t('用户地址') }}</td>
            <td colspan="6">{{model.userAddr}}</td>
          </tr>
          <tr>
            <td colspan="2">{{ $t('收费项目') }}</td>
            <td >{{ $t('购买吨数') }}</td>
            <td>{{ $t('单价') }}</td>
            <td >{{ $t('应收金额') }}</td>
            <td >{{ $t('上期结余') }}</td>
            <td >{{ $t('本期结余') }}</td>
          </tr>
          <tr>
            <td colspan="2">{{model.userPriceName}}</td>
            <td >{{model.payWaterNum}}</td>
            <td>{{(model.userPriceTotal-(model.userPriceCharge?model.userPriceCharge:0))|formatDecimal(2)}}</td>
            <td >{{(model.payWaterNum*(model.userPriceTotal-(model.userPriceCharge?model.userPriceCharge:0)))|formatDecimal(2)}}</td>
            <td >{{model.userPreAccountNum}}</td>
            <td >{{model.userNowAccountNum}}</td>
          </tr>
          <tr>
            <td colspan="2">{{model.userPriceItem1Name}}&nbsp;</td>
            <td >{{model.userPriceItem1?model.payWaterNum: ''}}</td>
            <td>{{model.userPriceItem1}}</td>
            <td >{{(model.payWaterNum*(model.userPriceItem1?model.userPriceItem1:0))|formatDecimal(2)}}</td>
            <td ></td>
            <td ></td>
          </tr>
          <tr>
            <td colspan="2">{{model.userPriceItem2Name}}&nbsp;</td>
            <td >{{model.userPriceItem2?model.payWaterNum: ''}}</td>
            <td>{{model.userPriceItem2}}</td>
            <td >{{(model.payWaterNum*(model.userPriceItem2?model.userPriceItem2:0))|formatDecimal(2)}}</td>
            <td ></td>
            <td ></td>
          </tr>
          <tr>
            <td colspan="2">{{model.userPriceItem3Name}}&nbsp;</td>
            <td >{{model.userPriceItem3?model.payWaterNum: ''}}</td>
            <td>{{model.userPriceItem3}}</td>
            <td >{{(model.payWaterNum*(model.userPriceItem3?model.userPriceItem3:0))|formatDecimal(2)}}</td>
            <td ></td>
            <td ></td>
          </tr>
          <tr>
            <td colspan="6" style="text-align:left;border-right-width: 0">{{ $t('实收金额：') }}{{model.userPayAccountNum|changeToChinese}}</td>
            <td style="border-left-width: 0">¥ {{model.userPayAccountNum}}</td>
          </tr>
          <tr>
            <td style="border-width: 0;text-align:left" colspan="3">{{ $t('收费员姓名：') }}{{model.updateBy?model.updateBy:model.createBy}}</td>
            <td colspan="4" style="border-width: 0;;text-align:left">
              {{ $t('打印日期：') }}{{moment().format('YYYY-MM-DD HH:mm:ss')}}
            </td>
          </tr>
        </table>
      </section>
    </a-card>
</template>
<script>
import { changeToChinese,formatDecimal } from '@/utils/util'
import {isUndefined,isNull} from '@/utils/validate'
import moment from "moment"
import { mapGetters } from 'vuex'
import {payTypeObj} from '@/utils/constants/commonConstant'
export default {
  filters: {changeToChinese,formatDecimal},
    props: {
        'model': Object
    },
    data() {
        return {
            visible: false,
            payType: payTypeObj
        }
    },
    methods: {
        moment,
        ...mapGetters(["nickname", "avatar","userInfo"]),
    }
}
</script>
<style>
#table td{text-align: center;border: 1px solid gray;}
.print-section{
  color: #000;
}
</style>